import { animate, style, transition, trigger } from '@angular/animations';

/**
 * Opens and closes a block with a height and opacity change.
 * The timings are the same as the expand animation of the assign leg modal.
 */
export const BLOCK_TIME_EXPAND_ANIMATION = trigger('expand', [
  transition(':enter', [
    style({ height: 0, opacity: 0, overflow: 'hidden' }),
    animate('220ms ease-out', style({ height: '*', opacity: 1 })),
  ]),
  transition(':leave', [style({ overflow: 'hidden' }), animate('180ms ease-in', style({ height: 0, opacity: 0 }))]),
]);
